import i18next from "i18next";

const mixin = {
  async beforeMount() {
    await this._onTranslate();
  },
  methods: {
    async _onTranslate() {
      this.$store.commit("setStatusLoadTranslate", "loading");

      const localeLng = this.$store.state.languages.find(
        (e) => e.flag === navigator.language.toLowerCase().replace("-", "_")
      ).flag;

      const lng = this.$store.state.language || localeLng || "en";

      try {
        const translation = await fetch(`/lang/${lng}.json`)
          .then((res) => res.json())
          .then((json) => json);

        await i18next.init({
          lng,
          ...(() => {
            return {
              resources: {
                [lng]: { translation },
              },
            };
          })(),
        });

        await i18next.changeLanguage(lng);
      } catch (e) {
        console.error(e);
      }

      this.$store.commit("setStatusLoadTranslate", "loaded");
    },
    convertValue(value, props = {}) {
      let result;
      if (props.type === "boolean" && String(value) === "true")
        result = this.$t("Sim");
      else if (props.type === "boolean" && String(value) === "false")
        result = this.$t("Nao");
      else if (props.type === "decimal") {
        result = this.$options.filters.number(Number(value), "0.00", {
          decimalSeparator: ",",
          thousandsSeparator: ".",
        });
      } else if (props.type === "text-date") {
        result = !/\d\d\/\d\d\/\d\d\d\d/.test(value)
          ? value
            ? new Date(value)
                .toJSON()
                .split("T")[0]
                .split("-")
                .reverse()
                .join("/")
            : ""
          : value.split("/").reverse().join("-");
      } else if (props.type === "date") {
        result = !/\d\d\/\d\d\/\d\d\d\d/.test(value)
          ? value
            ? new Date(value)
                .toJSON()
                .split("T")[0]
                .split("/")
                .reverse()
                .join("-")
            : ""
          : value.split("/").reverse().join("-");
      } else {
        result = value;
      }

      return result;
    },
    revokeAuth(errResponse) {
      if (errResponse.response && errResponse.response.status === 403) {
        this.$store.dispatch("auth/logout");
        this.$router.push("/login");
      }
    },
  },
  watch: {
    "$store.state.language"(next, prev) {
      if (next !== prev) {
        location.reload(true);
      }
    },
  },
};

export default mixin;
